import React from "react";
import styles from "./style.scss";

const Skeleton = ({ style = {}, className = "" }) => {
  return (
    <div className={`${styles.card} ${styles.isLoading} ${className}`} style={style}>
      <div className={styles.image}></div>
    </div>
  );
};

export default Skeleton;



// WEBPACK FOOTER //
// ./src/components/Skeleton/index.tsx